import React from "react";
import _ from "lodash";
import { FiCheckCircle, FiXCircle, FiFileText } from "react-icons/fi";
import ReactTooltip from "react-tooltip";
import HighLightRowWrapper from "components/common/HighLightRowWrapper";
import PriceSectionView from "components/common/PriceSectionView";
import SimpleTooltip from "components/common/SimpleTooltip";
import UprPriceSectionPopover from "./UprPriceSectionPopover";
import UprTargetingPopover from "./UprTargetingPopover";

class UPRSettingsTable extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      popupId: "",
    };
  }

  render() {
    const {
      items,
      units,
      virtualPlacements,
      placements,
      demandSource,
      networkInfo,
      handleOpenEdit,
      handleOpenEditJSON,
      handleRemoveRule,
      handleOpenDuplicate,
      handleOpenChangeLog,
      handleToggleEnabled,
      networkId,
      selectedItems = [],
      handleSelect,
      allItems,
      isSearch,
      readOnly = false,
      place,
    } = this.props;

    const { popupId } = this.state;

    // if (!items) return "";

    // if (items.length === 0) {
    //   return <div>No Custom UPRs</div>;
    // }

    const allItemsByEnabled = _.groupBy(allItems, "enabled");
    const allEnabledNum = _.get(allItemsByEnabled, ["true"], []).length;
    const allDisabledNum = _.get(allItemsByEnabled, ["false"], []).length;

    const itemsByEnabled = _.groupBy(items, "enabled");
    const enabledNum = _.get(itemsByEnabled, ["true"], []).length;
    const disabledNum = _.get(itemsByEnabled, ["false"], []).length;

    function handleSelectItem(itemId) {
      const tempList = [...selectedItems];
      if (itemId === "ALL") {
        const itemsList = _.map(items, (item) => item.id);
        const allItemsList = _.map(allItems, (item) => item.id);
        const newList = isAll()
          ? _.filter(tempList, (id) => !allItemsList.includes(id))
          : _.union(selectedItems, itemsList);
        handleSelect(newList);
        return;
      }

      const newList = tempList.includes(itemId)
        ? _.without(tempList, itemId)
        : [...tempList, itemId];
      handleSelect(newList);
    }

    function isAll() {
      if (!items || items.length === 0) return false;
      return (
        _.filter(items, (item) => {
          return selectedItems.indexOf(item.id) !== -1;
        }).length === items.length
      );
    }

    return (
      <div>
        <div className="-mt-6 flex justify-end gap-2 bg-white px-4 py-2 text-sm text-gray-700">
          <>
            <div className="flex items-center">
              <span className="text-green-600">
                <FiCheckCircle></FiCheckCircle>
              </span>
              : {isSearch && <span> {enabledNum} / </span>} {allEnabledNum}
            </div>
            <div className="flex items-center">
              <span className="text-red-600">
                <FiXCircle></FiXCircle>
              </span>
              : {isSearch && <span> {disabledNum} / </span>} {allDisabledNum}
            </div>
          </>
        </div>

        <table className="border shadow table w-full text-sm">
          <thead className="border-b bg-gray-200 text-xs text-blue-800">
            <tr>
              {!readOnly && (
                <th className="px-2 text-center" style={{ width: "35px" }}>
                  <input
                    style={{
                      width: "18px",
                      height: "18px",
                      marginTop: "4px",
                    }}
                    type="checkbox"
                    checked={isAll()}
                    onChange={() => handleSelectItem("ALL")}
                  ></input>
                </th>
              )}

              <th
                className="border px-2 py-1 text-center"
                style={{ width: "55px" }}
              >
                Enabled
              </th>
              <th className="border px-2 py-1 text-right">ID</th>
              <th className="border px-2 py-1"></th>
              <th
                className="border px-2 py-1 text-right"
                style={{ width: "70%" }}
              >
                Name
              </th>
              <th className="border px-2 py-1 text-center">Targeting</th>
              <th className="border px-2 py-1 text-right">Est. Criteria</th>
              <th className="border px-2 py-1 text-right">Prices</th>
              {!readOnly && (
                <th
                  className="border px-2 py-1 text-right"
                  style={{ width: "252px" }}
                >
                  Actions
                </th>
              )}
            </tr>
          </thead>
          <tbody className="bg-white text-gray-900">
            {(items || []).map((item, idx) => {
              const { targetingSection } = item;
              const countItem = {
                unitIds: (
                  (targetingSection &&
                    targetingSection.inventory &&
                    targetingSection.inventory.unitIds) ||
                  []
                ).length,
                excludedUnitIds: (
                  (targetingSection &&
                    targetingSection.inventory &&
                    targetingSection.inventory.excludedUnitIds) ||
                  []
                ).length,
                placementIds: (
                  (targetingSection &&
                    targetingSection.inventory &&
                    targetingSection.inventory.placementIds) ||
                  []
                ).length,
                virtualPlacementIds: (
                  (targetingSection &&
                    targetingSection.inventory &&
                    targetingSection.inventory.virtualPlacementIds) ||
                  []
                ).length,
                os: (
                  (targetingSection &&
                    targetingSection.os &&
                    (targetingSection.os.excludes ||
                      targetingSection.os.includes)) ||
                  []
                ).length,
                deviceCategory: (
                  (targetingSection &&
                    targetingSection.deviceCategory &&
                    (targetingSection.deviceCategory.excludes ||
                      targetingSection.deviceCategory.includes)) ||
                  []
                ).length,
                country: (
                  (targetingSection &&
                    targetingSection.country &&
                    (targetingSection.country.excludes ||
                      targetingSection.country.includes)) ||
                  []
                ).length,
                browser: (
                  (targetingSection &&
                    targetingSection.browser &&
                    (targetingSection.browser.excludes ||
                      targetingSection.browser.includes)) ||
                  []
                ).length,
                inventoryTypes: (
                  (targetingSection && targetingSection.inventoryTypes) ||
                  []
                ).length,
                inventoryUrl: (
                  (targetingSection &&
                    targetingSection.inventoryUrl &&
                    (targetingSection.inventoryUrl.excludes ||
                      targetingSection.inventoryUrl.includes)) ||
                  []
                ).length,
                mobileApplication: (
                  (targetingSection &&
                    targetingSection.mobileApplication &&
                    (targetingSection.mobileApplication.excludes ||
                      targetingSection.mobileApplication.includes)) ||
                  []
                ).length,
                videoPositions: (
                  (targetingSection && targetingSection.videoPositions) ||
                  []
                ).length,
                inventoryFormat: (
                  (targetingSection &&
                    targetingSection.inventoryFormat &&
                    (targetingSection.inventoryFormat.excludes ||
                      targetingSection.inventoryFormat.includes)) ||
                  []
                ).length,
                customs: (
                  (targetingSection && targetingSection.customs) ||
                  []
                ).reduce((acc, list) => {
                  return (
                    acc +
                    list.reduce((acc2, d) => {
                      return acc2 + d.valueIds.length;
                    }, 0)
                  );
                }, 0),
              };
              return (
                <HighLightRowWrapper
                  key={`${item.id}-${idx}`}
                  selected={popupId === item.id}
                >
                  {!readOnly && (
                    <td className="px-2 text-center">
                      <input
                        style={{
                          width: "18px",
                          height: "18px",
                          marginTop: "4px",
                        }}
                        type="checkbox"
                        checked={selectedItems.indexOf(item.id) !== -1}
                        onChange={() => handleSelectItem(item.id)}
                      ></input>
                    </td>
                  )}

                  <td className="border px-2 py-1 text-center">
                    <div className="flex items-center justify-center text-center text-lg">
                      {item.enabled ? (
                        <span className="text-green-600">
                          <FiCheckCircle></FiCheckCircle>
                        </span>
                      ) : (
                        <span className="text-red-600">
                          <FiXCircle></FiXCircle>
                        </span>
                      )}
                    </div>
                  </td>
                  <td className="border px-2 py-1 text-right">
                    <span
                      className={`font-mono ${
                        popupId === item.id ? "font-semibold" : ""
                      }`}
                    >
                      {item.id}
                    </span>
                  </td>
                  <td className="border px-2 py-1">
                    <SimpleTooltip tooltipText="View Change Logs">
                      <button
                        type="button"
                        className="text-gray-600 hover:text-blue-600"
                        onClick={() => handleOpenChangeLog(item)}
                      >
                        <FiFileText></FiFileText>
                      </button>
                    </SimpleTooltip>
                  </td>

                  <td
                    className={`border break-all px-2 py-1 text-right font-medium ${
                      popupId === item.id ? "font-semibold" : ""
                    }`}
                  >
                    {item.name}
                    {/* <div
                      className="break-words"
                      style={{ maxWidth: "200px", overflow: "scroll" }}
                    >
                      {item.name}
                    </div> */}
                  </td>

                  <td className="border px-2 py-1 text-center">
                    <UprTargetingPopover
                      id={item.id}
                      name={item.name}
                      networkId={networkId}
                      targetingSection={item.targetingSection}
                      units={units}
                      virtualPlacements={virtualPlacements}
                      placements={placements}
                      place={place}
                      triggerElement={
                        // <div className="cursor-pointer hover:underline">
                        //   {JSON.stringify(Object.keys(item.targetingSection))}
                        // </div>
                        <div>
                          <button
                            data-tip
                            data-for={item.id + item.name}
                            type="button"
                            className="rounded bg-blue-100 px-4 py-2 font-semibold text-blue-600 hover:bg-blue-200"
                          >
                            {Object.keys(item.targetingSection).length}
                          </button>
                          <ReactTooltip
                            id={item.id + item.name}
                            type="dark"
                            effect="solid"
                          >
                            {Object.keys(item.targetingSection).join(", ")}
                          </ReactTooltip>
                        </div>
                      }
                      onOpen={() => this.setState({ popupId: item.id })}
                      onClose={() => this.setState({ popupId: "" })}
                    ></UprTargetingPopover>
                  </td>

                  <td className="border px-2 py-1 text-right font-medium">
                    <SimpleTooltip
                      tooltipText={
                        <>
                          {_.sum(_.values(countItem)) > 0
                            ? _.keys(countItem)
                                .filter((key) => countItem[key] > 0)
                                .map((key) => (
                                  <div
                                    className="flex justify-between gap-2"
                                    key={key}
                                  >
                                    <span>{_.startCase(key)}: </span>
                                    <span>{countItem[key]}</span>
                                  </div>
                                ))
                            : "--"}
                        </>
                      }
                    >
                      {_.sum(_.values(countItem))}
                    </SimpleTooltip>
                  </td>

                  <td className="whitespace-no-wrap border px-2 py-1 text-right">
                    <div className="-mx-2 px-2">
                      <PriceSectionView
                        priceType={item.priceSection.priceType}
                        item={{
                          priceType: item.priceSection.priceType,
                          price: item.priceSection.price,
                        }}
                        currency={networkInfo.currency}
                      ></PriceSectionView>
                    </div>
                    {item.priceSection.brandedPriceSettings &&
                      item.priceSection.brandedPriceSettings.length > 0 && (
                        <div className="border-t">
                          <UprPriceSectionPopover
                            networkId={networkInfo.networkId}
                            currency={networkInfo.currency}
                            targetingSection={item.priceSection}
                            demandSource={demandSource}
                            triggerElement={
                              <div className="cursor-pointer hover:underline">
                                <BrandedPriceView
                                  item={item.priceSection}
                                  currency={networkInfo.currency}
                                ></BrandedPriceView>
                              </div>
                            }
                            place={place}
                            onOpen={() => this.setState({ popupId: item.id })}
                            onClose={() => this.setState({ popupId: "" })}
                          ></UprPriceSectionPopover>
                        </div>
                      )}
                  </td>
                  {!readOnly && (
                    <td className="whitespace-no-wrap border px-2 py-1 text-right">
                      <div className="flex items-center justify-end gap-4">
                        <button
                          type="button"
                          className={`rounded text-blue-600 hover:underline ${
                            item.enabled
                              ? "hover:text-red-600"
                              : "hover:text-green-600"
                          }`}
                          onClick={() => handleToggleEnabled(item)}
                        >
                          {item.enabled ? "Disable" : "Enable"}
                        </button>
                        <button
                          type="button"
                          className="text-blue-600 hover:underline"
                          onClick={() => handleOpenEdit(item)}
                        >
                          Edit
                        </button>
                        <button
                          type="button"
                          className="text-blue-600 hover:underline"
                          onClick={() => handleOpenEditJSON(item)}
                        >
                          JSON
                        </button>
                        <button
                          type="button"
                          className="text-blue-600 hover:underline"
                          onClick={() => handleOpenDuplicate(item)}
                        >
                          Duplicate
                        </button>
                        <button
                          type="button"
                          className="text-blue-600 hover:text-red-600 hover:underline"
                          onClick={() => handleRemoveRule(item)}
                        >
                          Remove
                        </button>
                      </div>
                    </td>
                  )}
                </HighLightRowWrapper>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

function BrandedPriceView({ item, currency }) {
  const { brandedPriceSettings } = item;

  return (
    <div>
      <span className="rounded bg-green-200 px-2 text-xs text-green-900">
        Branded ({brandedPriceSettings.length})
      </span>
    </div>
  );
}

export default UPRSettingsTable;
